import classNames from 'classnames'
import {memo} from 'react'

import type {TableHeaderItem} from '../../Parameters.types'
import {ParametersRow} from '../Row/ParametersRow'

import styles from './ParametersTableHeader.css'

interface Props {
  className?: string
  contentClassName?: string
  nameClassName?: string
  valueClassName?: string

  item: TableHeaderItem
}

function ParametersTableHeaderComponent(props: Props) {
  return (
    <ParametersRow
      role={'cell'}
      className={classNames(styles.content, props.className)}
      contentClassName={props.contentClassName}
      nameClassName={props.nameClassName}
      valueClassName={props.valueClassName}
      name={props.item.name}
      value={props.item.value}
    />
  )
}

export const ParametersTableHeader = memo<Props>(ParametersTableHeaderComponent)
